import { NavLink } from "react-router-dom";
import { useState } from "react";

export default function Sidebar() {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const menuItems = [
    { path: "/trainer", label: "لوحة التحكم", icon: "📊", end: true },
    { path: "/trainer/students/create", label: "الطلاب", icon: "👨‍🎓" },
    { path: "/trainer/contacts", label: "روابط التواصل", icon: "📱" },
    { path: "/trainer/courses/create", label: "إنشاء كورس", icon: "🆕" },
    { path: "/trainer/courses", label: "الكورسات", icon: "📚" },
    { path: "/trainer/profile", label: "الملف الشخصي", icon: "👤" },
  ];

  return (
    <div style={styles.container}>
      <aside style={{
        ...styles.sidebar,
        width: isCollapsed ? '80px' : '280px',
      }}>
        {/* رأس السايدبار */}
        <div style={styles.header}>
          <button 
            onClick={() => setIsCollapsed(!isCollapsed)}
            style={styles.collapseButton}
            title={isCollapsed ? "توسيع" : "طي"}
          >
            {isCollapsed ? "←" : "→"}
          </button>
          {!isCollapsed && (
            <div style={styles.brand}>
              <h1 style={styles.title}>نظام المدرّب</h1>
              <div style={styles.logo}>🏋️</div>
            </div>
          )}
        </div>

        {/* قائمة التنقل */}
        <nav style={styles.nav}>
          <ul style={styles.menu}>
            {menuItems.map((item) => (
              <li key={item.path} style={styles.menuItem}>
                <NavLink
                  to={item.path}
                  end={item.end}
                  style={({ isActive }) => ({
                    ...styles.menuLink,
                    ...(isActive ? styles.menuLinkActive : {}),
                    padding: isCollapsed ? '15px 10px' : '15px 20px',
                    justifyContent: isCollapsed ? 'center' : 'flex-start',
                  })}
                >
                  {!isCollapsed && (
                    <span style={styles.menuArrow}>‹</span>
                  )}
                  {!isCollapsed && (
                    <span style={styles.menuLabel}>{item.label}</span>
                  )}
                  <span style={styles.menuIcon}>{item.icon}</span>
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>

        {/* قسم المستخدم */}
        {!isCollapsed && (
          <div style={styles.userSection}>
            <div style={styles.userInfo}>
              <div style={styles.userDetails}>
                <h3 style={styles.userName}>المدرّب محمد</h3>
                <p style={styles.userRole}>مدرب محترف</p>
              </div>
              <div style={styles.userAvatar}>
                <span style={styles.avatarText}>م</span>
              </div>
            </div>
            <div style={styles.userStats}>
              <div style={styles.stat}>
                <span style={styles.statLabel}>طالب</span>
                <span style={styles.statNumber}>12</span>
              </div>
              <div style={styles.stat}>
                <span style={styles.statLabel}>كورس</span>
                <span style={styles.statNumber}>5</span>
              </div>
            </div>
          </div>
        )}

        {/* تذييل السايدبار */}
        {!isCollapsed && (
          <div style={styles.footer}>
            <button style={styles.logoutButton}>
              <span>تسجيل الخروج</span>
              <span style={styles.logoutIcon}>🚪</span>
            </button>
            <p style={styles.footerText}>الإصدار 2.1.0</p>
          </div>
        )}
      </aside>

      <style>{`
        @keyframes slideIn {
          from { transform: translateX(20px); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
        
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        
        .menu-link-active {
          position: relative;
        }
        
        .menu-link-active::before {
          content: '';
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 4px;
          height: 70%;
          background: linear-gradient(to bottom, #667eea, #764ba2);
          border-radius: 4px 0 0 4px;
        }
        
        .menu-link-hover:hover {
          transform: translateX(-5px);
        }
        
        .menu-link-hover:active {
          transform: translateX(-2px);
        }
        
        .collapse-btn-hover:hover {
          background: rgba(255, 255, 255, 0.2) !important;
          transform: scale(1.1);
        }
        
        .logout-btn-hover:hover {
          background: rgba(244, 67, 54, 0.1) !important;
          border-color: #f44336 !important;
          color: #f44336 !important;
        }
        
        @media (max-width: 768px) {
          .sidebar-responsive {
            position: fixed !important;
            height: 100vh !important;
            z-index: 1000 !important;
            transform: translateX(100%);
            transition: transform 0.3s ease !important;
            right: 0 !important;
          }
          
          .sidebar-responsive.open {
            transform: translateX(0);
          }
        }
      `}</style>
    </div>
  );
}

const styles = {
  container: {
    position: 'relative',
    height: '100vh',
  },
  sidebar: {
    height: '100%',
    background: 'linear-gradient(180deg, #2c3e50 0%, #1a2530 100%)',
    color: 'white',
    display: 'flex',
    flexDirection: 'column',
    transition: 'all 0.3s ease',
    boxShadow: '-5px 0 25px rgba(0, 0, 0, 0.2)',
    position: 'relative',
    overflow: 'hidden',
    direction: 'ltr',
  },
  header: {
    padding: '25px 20px',
    borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'relative',
    direction: 'rtl',
  },
  brand: {
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
    animation: 'slideIn 0.5s ease-out',
    direction: 'rtl',
  },
  logo: {
    fontSize: '2.5rem',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    width: '60px',
    height: '60px',
    borderRadius: '15px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 5px 15px rgba(102, 126, 234, 0.4)',
  },
  title: {
    margin: 0,
    fontSize: '1.4rem',
    fontWeight: '700',
    background: 'linear-gradient(to left, #fff, #e0e0e0)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
  },
  collapseButton: {
    background: 'rgba(255, 255, 255, 0.1)',
    border: 'none',
    color: 'white',
    width: '35px',
    height: '35px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    fontSize: '1.2rem',
    transition: 'all 0.3s ease',
    position: 'absolute',
    right: '20px',
    top: '50%',
    transform: 'translateY(-50%)',
  },
  nav: {
    flex: 1,
    padding: '20px 0',
    overflowY: 'auto',
    direction: 'rtl',
  },
  menu: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    direction: 'rtl',
  },
  menuItem: {
    marginBottom: '5px',
    animation: 'fadeIn 0.5s ease-out',
    direction: 'rtl',
  },
  menuLink: {
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
    color: 'rgba(255, 255, 255, 0.8)',
    textDecoration: 'none',
    padding: '15px 20px',
    margin: '0 10px',
    borderRadius: '12px',
    transition: 'all 0.3s ease',
    position: 'relative',
    overflow: 'hidden',
    direction: 'rtl',
  },
  menuLinkActive: {
    background: 'linear-gradient(90deg, rgba(118, 75, 162, 0.2) 0%, rgba(102, 126, 234, 0.2) 100%)',
    color: 'white',
    boxShadow: '0 5px 15px rgba(0, 0, 0, 0.2)',
  },
  menuIcon: {
    fontSize: '1.5rem',
    minWidth: '30px',
    textAlign: 'center',
  },
  menuLabel: {
    flex: 1,
    fontSize: '1rem',
    fontWeight: '500',
    textAlign: 'right',
  },
  menuArrow: {
    fontSize: '1.2rem',
    opacity: '0.7',
    transform: 'rotate(180deg)',
  },
  userSection: {
    padding: '25px 20px',
    borderTop: '1px solid rgba(255, 255, 255, 0.1)',
    borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
    animation: 'slideIn 0.5s ease-out',
    direction: 'rtl',
  },
  userInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
    marginBottom: '20px',
    direction: 'rtl',
  },
  userAvatar: {
    width: '60px',
    height: '60px',
    borderRadius: '50%',
    background: 'linear-gradient(135deg, #4CAF50 0%, #2E7D32 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '1.8rem',
    fontWeight: 'bold',
    boxShadow: '0 5px 15px rgba(76, 175, 80, 0.3)',
  },
  avatarText: {
    color: 'white',
  },
  userDetails: {
    flex: 1,
    textAlign: 'right',
  },
  userName: {
    margin: '0 0 5px 0',
    fontSize: '1.1rem',
    fontWeight: '600',
  },
  userRole: {
    margin: 0,
    fontSize: '0.9rem',
    color: 'rgba(255, 255, 255, 0.7)',
  },
  userStats: {
    display: 'flex',
    gap: '20px',
    direction: 'rtl',
  },
  stat: {
    flex: 1,
    textAlign: 'center',
    background: 'rgba(255, 255, 255, 0.05)',
    padding: '12px',
    borderRadius: '10px',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    display: 'flex',
    flexDirection: 'column',
  },
  statNumber: {
    fontSize: '1.5rem',
    fontWeight: '700',
    color: '#667eea',
    marginBottom: '5px',
  },
  statLabel: {
    fontSize: '0.8rem',
    color: 'rgba(255, 255, 255, 0.7)',
  },
  footer: {
    padding: '20px',
    textAlign: 'center',
    animation: 'fadeIn 0.5s ease-out',
    direction: 'rtl',
  },
  logoutButton: {
    width: '100%',
    padding: '12px',
    background: 'rgba(255, 255, 255, 0.05)',
    color: 'rgba(255, 255, 255, 0.8)',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    borderRadius: '10px',
    fontSize: '1rem',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    marginBottom: '15px',
    direction: 'rtl',
  },
  logoutIcon: {
    fontSize: '1.2rem',
  },
  footerText: {
    fontSize: '0.8rem',
    color: 'rgba(255, 255, 255, 0.5)',
    margin: 0,
  },
};

// إضافة classes للتأثيرات
if (typeof window !== 'undefined') {
  setTimeout(() => {
    const style = document.createElement('style');
    style.textContent = `
      .menu-link-hover:hover {
        background: rgba(255, 255, 255, 0.1) !important;
        color: white !important;
        transform: translateX(-5px);
      }
      
      .collapse-btn-hover:hover {
        background: rgba(255, 255, 255, 0.2) !important;
        transform: scale(1.1);
      }
      
      .logout-btn-hover:hover {
        background: rgba(244, 67, 54, 0.1) !important;
        border-color: #f44336 !important;
        color: #f44336 !important;
      }
      
      .stat-hover:hover {
        background: rgba(255, 255, 255, 0.1) !important;
        transform: translateY(-2px);
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2) !important;
      }
      
      .avatar-hover:hover {
        transform: rotate(-10deg) scale(1.1);
      }
      
      ::-webkit-scrollbar {
        width: 5px;
      }
      
      ::-webkit-scrollbar-track {
        background: rgba(255, 255, 255, 0.05);
        border-radius: 10px;
      }
      
      ::-webkit-scrollbar-thumb {
        background: rgba(102, 126, 234, 0.5);
        border-radius: 10px;
      }
      
      ::-webkit-scrollbar-thumb:hover {
        background: rgba(102, 126, 234, 0.8);
      }
      
      @media (max-width: 768px) {
        .mobile-overlay {
          display: none;
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5);
          z-index: 999;
        }
        
        .mobile-overlay.active {
          display: block;
        }
        
        .mobile-menu-btn {
          display: block !important;
          position: fixed;
          top: 20px;
          left: 20px;
          z-index: 1001;
          background: #2c3e50;
          color: white;
          border: none;
          border-radius: 50%;
          width: 50px;
          height: 50px;
          font-size: 1.5rem;
          cursor: pointer;
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
        }
      }
    `;
    document.head.appendChild(style);
  }, 100);
}

// إضافة تأثيرات Hover
const addSidebarEffects = () => {
  if (typeof window !== 'undefined') {
    setTimeout(() => {
      document.querySelectorAll('[style*="menuLink"]').forEach(el => {
        el.className = (el.className || '') + ' menu-link-hover';
      });
      document.querySelectorAll('[style*="collapseButton"]').forEach(el => {
        el.className = (el.className || '') + ' collapse-btn-hover';
      });
      document.querySelectorAll('[style*="logoutButton"]').forEach(el => {
        el.className = (el.className || '') + ' logout-btn-hover';
      });
      document.querySelectorAll('[style*="stat"]').forEach(el => {
        el.className = (el.className || '') + ' stat-hover';
      });
      document.querySelectorAll('[style*="userAvatar"]').forEach(el => {
        el.className = (el.className || '') + ' avatar-hover';
      });
    }, 200);
  }
};

// إضافة زر القائمة للجوال
const addMobileMenu = () => {
  if (typeof window !== 'undefined' && window.innerWidth <= 768) {
    const menuBtn = document.createElement('button');
    menuBtn.className = 'mobile-menu-btn';
    menuBtn.textContent = '☰';
    menuBtn.onclick = () => {
      const sidebar = document.querySelector('[style*="sidebar"]');
      const overlay = document.createElement('div');
      overlay.className = 'mobile-overlay active';
      overlay.onclick = () => {
        sidebar.style.transform = 'translateX(100%)';
        overlay.remove();
      };
      document.body.appendChild(overlay);
      sidebar.style.transform = 'translateX(0)';
    };
    document.body.appendChild(menuBtn);
  }
};

// تشغيل التأثيرات عند التحميل
if (typeof window !== 'undefined') {
  addSidebarEffects();
  addMobileMenu();
  
  // تحديث عند تغيير حجم النافذة
  window.addEventListener('resize', addMobileMenu);
}